import React, { useState, useCallback, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import Suggestions from "../Utils/Suggestions";
import { conditionStatus, durationType } from "../initialData/initialData";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import { Grid, Autocomplete, Typography, Card } from "@mui/material";
import dayjs from "dayjs";
import { StyledTextField, StyledDatePicker, theme } from "../StyledComponents";
import { appointmentData } from "../Utils/SectionsDataMap";
import { FIELD_SET_IDS } from "../config/defaults/fieldLayoutUtils";
import useSectionFieldLayout from "../config/hooks/useSectionFieldLayout";

const Referral = ({
  sectionName,
  activeSection,
  data,
  setData,
  setAppointmentError,
  appointmentError,
  details,
  setDetails,
  fieldLayout: fieldLayoutProp,
}) => {
  const fieldLayout = useSectionFieldLayout(
    fieldLayoutProp,
    FIELD_SET_IDS.referral,
  );
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const [departments, setDepartments] = useState([]);
  const [doctors, setDoctors] = useState([]);
  const [validationErrors, setValidationErrors] = useState(appointmentError);
  // const [details, setDetails] = useState(
  //   data.length > 0
  //     ? data[0]
  //     : {
  //         service_category: null,
  //         service_description: "",
  //         doctor_details: null,
  //       }
  // );
  console.log("Appointment Error", appointmentError);
  const handleInputChange = (field, value) => {
    console.log("Term and its value", field, value);
    let newDetails;
    console.log("Details", details);
    let detailsObj;
    if (field == "service_category") {
      if (!value) {
        setDoctors([]);
      } else {
        getDoctorsByDepartment(value);
      }

      detailsObj = {
        ...details,
        [field]: value,
        doctor_details: null,
      };
    } else {
      detailsObj = {
        ...details,
        [field]: value,
      };
    }

    newDetails = [{ ...detailsObj }];
    console.log("New Details", newDetails);
    setDetails(detailsObj);
    setData(newDetails);
    validateFields(newDetails[0]);
  };
  const validateFields = (detail) => {
    const errors = {};

    if (
      fieldLayout.isFieldVisible("service_description", detail) &&
      fieldLayout.isFieldRequired("service_description", detail) &&
      !detail.service_description?.trim()
    ) {
      errors.service_description = fieldLayout.getValidationMessage(
        "service_description",
        "Referral Details is a mandatory field.",
      );
    } else if (detail.doctor_details && !detail.service_description) {
      // Referral Details is mandatory if Doctor is selected
      errors.service_description =
        "Referral Details is required if doctor is selected.";
    }

    if (
      fieldLayout.isFieldVisible("service_category", detail) &&
      fieldLayout.isFieldRequired("service_category", detail) &&
      !detail.service_category
    ) {
      errors.service_category = fieldLayout.getValidationMessage(
        "service_category",
        "Department is a mandatory field.",
      );
    } else if (
      detail.service_description &&
      !detail.service_category &&
      !detail.doctor_details
    ) {
      // Doctor/Department are mandatory if Referral Details is given
      errors.service_category =
        "Choose Department when Referral Details is given.";
    } else if (detail.doctor_details && !detail.service_category) {
      // Department is mandatory if Doctor is selected
      errors.service_category =
        "Department selection is required if a doctor is selected.";
    }

    if (
      fieldLayout.isFieldVisible("doctor_details", detail) &&
      fieldLayout.isFieldRequired("doctor_details", detail) &&
      !detail.doctor_details
    ) {
      errors.doctor_details = fieldLayout.getValidationMessage(
        "doctor_details",
        "Doctor is a mandatory field.",
      );
    } else if (
      detail.service_description &&
      !detail.service_category &&
      !detail.doctor_details
    ) {
      errors.doctor_details = "Choose Doctor when Referral Details is given.";
    } else if (detail.service_category && !detail.doctor_details) {
      // Doctor is mandatory if Department is selected
      errors.doctor_details =
        "Doctor selection is required if a department is selected.";
    }

    // Update the validationErrors state
    setValidationErrors(errors);
    setAppointmentError(errors);

    // return Object.keys(errors).length === 0; // Return true if no errors
  };

  console.log("Appointment", data, details);
  const getAllDepartments = () => {
    axios
      .get(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`,
        { headers }
      )
      .then((res) => {
        let updatedList = res.data.department_list.map((dep) => dep.department);
        //For adding outside facility doctors
        updatedList.push("Other/External");
        setDepartments(updatedList);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getDoctorsByDepartment = (department) => {
    axios
      .post(
        `${process.env.REACT_APP_BACKEND_ROUTE_URL}get_all_doctors_based_on_department/`,
        { department },
        { headers }
      )
      .then((res) => {
        if (res.data.response_list) {
          let updatedDoctors = res.data.response_list.map((doctor) => {
            return {
              doctor_id: doctor.doctor_id,
              name: doctor.name,
            };
          });

          console.log("Updated Doctors", updatedDoctors);
          setDoctors(updatedDoctors);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    getAllDepartments();
  }, []);
  return (
    <ThemeProvider theme={theme}>
      {activeSection ? (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
            marginTop: 1,
          }}
        >
          <Grid item xs={12} sm={12} md={12}>
            <Typography
              sx={{ marginLeft: 1 }}
              color="textPrimary"
              style={{ marginTop: "1%" }}
            >
              Referral
            </Typography>
            <Grid
              container
              spacing={2}
              sx={{
                // marginTop: "5px",
                padding: "10px",
              }}
            >
              {/* <Grid item xs={6} sm={3}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <StyledDatePicker
                  label="Follow-up Date"
                  format="DD-MM-YYYY"
                  onChange={(date) => handleInputChange("start_date", date)}
                  minDate={dayjs()} // Minimum date is set to today
                  slotProps={{
                    textField: {
                      error: !!validationErrors.start_date, // Pass the error prop to TextField
                      helperText: validationErrors.start_date, // Display helper text for the error
                    },
                    field: { clearable: true },
                  }}
                  value={
                    details?.start_date ? dayjs(details?.start_date) : null
                  }
                />
              </LocalizationProvider>
            </Grid> */}
              {fieldLayout.isFieldVisible("service_description", details) && (
              <Grid item {...fieldLayout.getFieldGrid("service_description", { xs: 6, sm: 6 })}>
                <StyledTextField
                  fullWidth
                  label={fieldLayout.getFieldLabel(
                    "service_description",
                    "Referral Details",
                    details,
                  )}
                  value={details.service_description}
                  onChange={(e) =>
                    handleInputChange("service_description", e.target.value)
                  }
                  error={!!validationErrors.service_description}
                  helperText={validationErrors.service_description}
                />
              </Grid>
              )}
              {fieldLayout.isFieldVisible("service_category", details) && (
              <Grid item {...fieldLayout.getFieldGrid("service_category", { xs: 6, sm: 3 })}>
                <Autocomplete
                  options={departments}
                  value={details.service_category}
                  onChange={(event, newValue) =>
                    handleInputChange("service_category", newValue)
                  }
                  slotProps={{
                    paper: {
                      sx: {
                        "& .MuiAutocomplete-listbox": {
                          fontSize: "12px", //sets option font size
                        },
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <StyledTextField
                      {...params}
                      label={fieldLayout.getFieldLabel(
                        "service_category",
                        "Select Department",
                        details,
                      )}
                      fullWidth
                      error={!!validationErrors.service_category}
                      helperText={validationErrors.service_category}
                    />
                  )}
                />
              </Grid>
              )}
              {fieldLayout.isFieldVisible("doctor_details", details) && (
              <Grid item {...fieldLayout.getFieldGrid("doctor_details", { xs: 6, sm: 3 })}>
                <Autocomplete
                  key={
                    details.service_category === "Other/External"
                      ? "other-category"
                      : "default-category"
                  } // Force re-render when service_category changes
                  options={doctors}
                  getOptionLabel={(option) => option.name}
                  freeSolo={details.service_category === "Other/External"} // Enable freeSolo only when service_category is "Other/External"
                  value={details.doctor_details || null}
                  slotProps={{
                    paper: {
                      sx: {
                        "& .MuiAutocomplete-listbox": {
                          fontSize: "12px", //sets option font size
                        },
                      },
                    },
                  }}
                  renderInput={(params) => (
                    <StyledTextField
                      {...params}
                      label={fieldLayout.getFieldLabel(
                        "doctor_details",
                        details.service_category === "Other/External"
                          ? "Type a Doctor Name"
                          : "Select a Doctor",
                        details,
                      )}
                      variant="outlined"
                      error={!!validationErrors.doctor_details}
                      helperText={validationErrors.doctor_details}
                    />
                  )}
                  onChange={(event, value) => {
                    value && handleInputChange("doctor_details", value);
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (details.service_category === "Other/External") {
                      handleInputChange("doctor_details", {
                        doctor_id: `9999-${newInputValue}`,
                        name: newInputValue,
                      });
                    }
                  }}
                />
              </Grid>
              )}
            </Grid>
          </Grid>
        </Card>
      ) : (
        // appointmentData([{ ...details }], appointmentError)
        []
      )}
    </ThemeProvider>
  );
};

export default Referral;
